import { config } from '../config';

/** Цель Метрики: переход в Google Play */
export function trackGooglePlayGoal() {
  if (typeof window !== 'undefined' && typeof window.ym === 'function') {
    window.ym(config.yandexMetrikaId, 'reachGoal', 'googleplay');
  }
}
